// Feature flags that replaced hardcoded per-tenant checks
// (`allowedOnThemes`, `<ThemeSpecific>`, `currentTheme === Theme.AMSM`).
//
// "Which tenant has which feature" is now data: each flag is seeded off in
// every tenant database and turned on for the tenants that used to be
// hardcoded by amsm-backend's feature_flags migrations 0019/0020 — see
// docs/adr/0007-tenant-specific-behavior-via-feature-flags.md. An
// administrator changes it per tenant in Django admin, no deploy needed.
//
// Gate a route or navigation entry with `featureFlag: TENANT_FLAG.X`, a
// piece of UI with `<FeatureFlagSpecific flag={TENANT_FLAG.X}>`, or read it
// with `useFeatureFlag(TENANT_FLAG.X)`.
//
// The tenant theme (`useCurrentTheme`) is still what picks branding —
// colors, logos, tenant-specific copy and icons — just no longer features.
export const TENANT_FLAG = {
  ADMINISTRATION_NAVIGATION: 'administration_navigation',
  DJANGO_ADMIN_LINK: 'django_admin_link',
  FINANCES_MODULE: 'finances_module',
  ACCOUNTS_PAYABLE_RECEIVABLE: 'accounts_payable_receivable',
  NFSE_ISSUANCE: 'nfse_issuance',
  FINANCIAL_DOCUMENTS_LIST: 'financial_documents_list',
  PAYMENT_METHODS_SYNC: 'payment_methods_sync',
  USER_FINANCIAL_DOCUMENTS: 'user_financial_documents',
  FINANCES_SCHOOL_REPORTS: 'finances_school_reports',
  PHYSICAL_ACCESS_CONTROL: 'physical_access_control',
  GYM_ACCESS_DASHBOARD: 'gym_access_dashboard',
  PHYSICAL_SPACE_RESERVATIONS: 'physical_space_reservations',
  SPACE_RENTING: 'space_renting',
  DASHBOARD_MY_RESERVATIONS: 'dashboard_my_reservations',
  CALENDAR: 'calendar',
  CALENDAR_LIST_VIEW: 'calendar_list_view',
  ASSOCIATION_TITLES: 'association_titles',
  BENEFITS: 'benefits',
  BENEFIT_POINTS: 'benefit_points',
  GYM_MODULE: 'gym_module',
  GYM_TEACHER_DASHBOARD: 'gym_teacher_dashboard',
  DASHBOARD_GYM_SHORTCUT: 'dashboard_gym_shortcut',
  CLASS_BOOKING: 'class_booking',
  CONTRACTS_MODULE: 'contracts_module',
  CONTRACTS_CRM: 'contracts_crm',
  CONTRACTS_CRM_OWN_CONTRACTS_BY_DEFAULT:
    'contracts_crm_own_contracts_by_default',
  CAMPAIGNS: 'campaigns',
  EVENTS: 'events',
  USER_EVENTS_TAB: 'user_events_tab',
  SCHOOLS: 'schools',
  USER_MODALITIES_TAB: 'user_modalities_tab',
  CUSTOM_REPORT: 'custom_report',
  HEALTH_AND_LIFE_INSURANCE: 'health_and_life_insurance',
  USER_RESPONSIBLES_STEP: 'user_responsibles_step',
  DRIVERS_LUNCH_FIELD: 'drivers_lunch_field',
  USER_FORM_LEGACY_CPF_BY_DEFAULT: 'user_form_legacy_cpf_by_default',
  RAFFLE: 'raffle',
  USER_MEMBER_TABS: 'user_member_tabs',
  USER_LIST_SHOWS_ALL_BY_DEFAULT: 'user_list_shows_all_by_default',
  VITAL_SIGNS_REPORT: 'vital_signs_report',
}
